/*
  This is a placeholder View
*/

// Global npm libraries
import React from 'react'

class Placeholder2 extends React.Component {
  constructor (props) {
    super(props)

    console.log('Placeholder 2 loaded.')
  }

  render () {
    return (
      <>
        <p style={{ padding: '25px' }}>This is placeholder View #2</p>
      </>
    )
  }
}

export default Placeholder2
